<template>
    <div>
        <b-card
                :class="{'border border-danger':stockItem.is_unavailable}"
                :title="stockItem.product" :img-src="stockItem.image">

            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    inventar
                    <span>{{stockItem.inventory}}</span>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    Verkaufsnummer
                    <span>{{stockItem.orders_count}}</span>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    Anzahl der Verkäufe heute
                    <span :class="{'text-success font-weight-bold':stockItem.orders_count_today > 0}">{{stockItem.orders_count_today}}</span>
                </b-list-group-item>
            </b-list-group>

            <div class="text-center">
                <b-link
                        :to="{name:'DetailsStock',params:{'productid':stockItem.product_id}}"
                        class="btn btn-info btn-round">{{$t('detailsTitle')}}</b-link>
            </div>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "StockItem",
        props: {
            stockItem: {
                type: Object,
                default: null
            }
        }
    }
</script>

<style scoped>

</style>